var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouritesD(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1153 0.00120377C10.6373 0.0347948 9.26562 0.77707 8.42908 1.99599C7.59405 0.777669 6.22429 0.0350063 4.74769 0C2.06017 0.147592 -0.0324607 2.38894 0.00451542 5.08026V5.16453C-0.00150514 5.23261 -0.00150514 5.3011 0.00451542 5.36918C0.233247 12.195 8.43148 15 8.43148 15C8.43148 15 16.6261 12.195 16.8584 5.36918C16.8633 5.30105 16.8633 5.23266 16.8584 5.16453V5.08026C16.8941 2.38964 14.802 0.149383 12.1153 0.00120377Z",
    fill: "var(--gray-40)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouritesD);
export default __webpack_public_path__ + "static/media/favourites-D.701b6fbabd3595cd278833fcace2e8c2.svg";
export { ForwardRef as ReactComponent };